import { render, staticRenderFns } from "./task_inspection.vue?vue&type=template&id=7f903c8c&scoped=true"
import script from "./task_inspection.vue?vue&type=script&lang=js"
export * from "./task_inspection.vue?vue&type=script&lang=js"
import style0 from "./task_inspection.vue?vue&type=style&index=0&id=7f903c8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f903c8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f903c8c')) {
      api.createRecord('7f903c8c', component.options)
    } else {
      api.reload('7f903c8c', component.options)
    }
    module.hot.accept("./task_inspection.vue?vue&type=template&id=7f903c8c&scoped=true", function () {
      api.rerender('7f903c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/task_inspection.vue"
export default component.exports